import { render, staticRenderFns } from "./VehicleLookupForm.vue?vue&type=template&id=20fb0b3e"
import script from "./VehicleLookupForm.vue?vue&type=script&lang=ts"
export * from "./VehicleLookupForm.vue?vue&type=script&lang=ts"
import style0 from "./VehicleLookupForm.vue?vue&type=style&index=0&id=20fb0b3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports